import { PlayersList } from "../../../components/player/PlayersList";
import { PlayerShortDto, PlayersFilterBy } from "../../../types/player";
import { TeamContext } from "../../../types/common";
import { FC, useEffect, useState } from "react";
import { getPlayers } from "../../../api/transport/playersTransport";
import { Tabs, type TabsProps } from 'antd';
import { SolutionOutlined } from "@ant-design/icons";
import { RadioGroup } from "../../../components/RadioGroup";
import { Link } from "../../../components";
import { setDocumentTitle } from "../../../utils";
import { useNavigate, useParams } from "react-router";
import { getAcademyYearByTeam, getTeamByYear } from "./helpers";

enum PlayersGroup {
    PLAYERS = 'players',
    GRADUATES = 'graduates',
}

interface AcademyPlayersPageProps { }

export const AcademyPlayersPage: FC<AcademyPlayersPageProps> = () => {
    const [loading, setLoading] = useState(true);
    const [players, setPlayers] = useState<PlayerShortDto[]>([]);
    const [selectedYear, setSelectedYear] = useState('10');
    const [playersType, setPlayersType] = useState(PlayersGroup.PLAYERS);

    const params = useParams();
    const navigate = useNavigate();
    const teamYear = params.teamYear;

    useEffect(() => {
        if (!teamYear || isNaN(+teamYear)) {
            const searchParams = new URLSearchParams(window.location.hash.slice(1));
            let searchYear = searchParams.get('year');
            const searchType = searchParams.get('type') || PlayersGroup.PLAYERS;

            if (!searchYear) {
                if (searchType === PlayersGroup.GRADUATES) {
                    searchYear = itemGroups[searchType][itemGroups[searchType].length - 1].key;
                } else {
                    searchYear = itemGroups[searchType][0].key;
                }
            }

            navigate(`/academy/team/${getAcademyYearByTeam(searchYear)}/`, {
                replace: true
            });
            return;
        }

        const teamInfo = getTeamByYear(+teamYear);

        if (!teamInfo) {
            navigate(`/academy/team/`, {
                replace: true
            });
            return;
        }

        const playersGroup = !!teamInfo.graduated ? PlayersGroup.GRADUATES : PlayersGroup.PLAYERS;
        setPlayersType(playersGroup);
        setSelectedYear(teamInfo.key.toString());

        setDocumentTitle(`Игроки Родина ${teamYear} - Команды Академии - Официальный сайт Академия «Родина»`);

        setLoading(true);

        getPlayers(TeamContext.ACADEMY, `?year=${teamInfo.key}`)
            .then((data) => {
                setPlayers(data);
            })
            .finally(() => {
                setLoading(false);
            });

    }, [teamYear]);

    useEffect(() => {
        setDocumentTitle(`Команды Академии - Официальный сайт Академия «Родина»`);
    }, []);

    const itemGroups: Record<PlayersGroup, TabsProps['items']> = {
        [PlayersGroup.PLAYERS]: [
            {
                key: '10',
                label: 'Родина 2009',
            },
            {
                key: '11',
                label: 'Родина 2010',
            },
            {
                key: '13',
                label: 'Родина 2011',
            },
            {
                key: '15',
                label: 'Родина 2012',
            },
            {
                key: '16',
                label: 'Родина 2013',
            },
            {
                key: '17',
                label: 'Родина 2014',
            },
            {
                key: '18',
                label: 'Родина 2015',
            },
            {
                key: '19',
                label: 'Родина 2016'
            },
        ],
        [PlayersGroup.GRADUATES]: [
            {
                key: '1',
                label: 'Родина 2000',
            },
            {
                key: '2',
                label: 'Родина 2001',
            },
            {
                key: '3',
                label: 'Родина 2002',
            },
            {
                key: '4',
                label: 'Родина 2003',
            },
            {
                key: '5',
                label: 'Родина 2004',
            },
            {
                key: '6',
                label: 'Родина 2005',
            },
            {
                key: '7',
                label: 'Родина 2006',
            },
            {
                key: '8',
                label: 'Родина 2007',
            },
            {
                key: '9',
                label: 'Родина 2008',
            },
        ],
    }

    return (
        <div className="px-3 py-4 max-w-[1024px] mx-auto">
            <div className="pb-8 flex flex-row items-center justify-between" style={{ fontFamily: 'Futura, sans-serif' }}>
                <h1 className="text-2xl sm:text-3xl font-semibold text-slate-900">Команды Академии</h1>
                <Link to="/academy/" className="sm:text-lg flex flex-row gap-2 items-center justify-end transition-all bg-slate-200 px-3 py-1 sm:px-4 sm:py-2 rounded-full cursor-pointer active:scale-95 hover:bg-sky-600 hover:text-white text-sky-900 hover:no-underline hover:shadow-sm">
                    <span>
                        Профессионалы
                    </span>
                    <SolutionOutlined />
                </Link>
            </div>
            <div className="flex items-center justify-center w-full pb-4">
                <RadioGroup
                    options={[
                        { key: PlayersGroup.PLAYERS, label: 'Действующие игроки' },
                        { key: PlayersGroup.GRADUATES, label: 'Выпускники' },
                    ]}
                    value={playersType}
                    onChange={(v) => {
                        navigate(`/academy/team#type=${v}`)
                    }}
                    size="large"
                />
            </div>
            <Tabs
                activeKey={selectedYear}
                items={itemGroups[playersType]}
                onChange={(key) => navigate(`/academy/team/${getAcademyYearByTeam(key)}/`)}
                centered
            />
            <PlayersList
                defaultFilter={PlayersFilterBy.Position}
                loading={loading}
                players={players as PlayerShortDto[]}
                showBirthDate
                noStats={+selectedYear > 16}
            />
        </div>
    );
};